import { jsx as _jsx } from "react/jsx-runtime";
import { useAuthContext } from "../context.js";
import { AddPasskey } from "./add-passkey.js";
import { EoaConnectCard, EoaPickCard, WalletConnectCard } from "./eoa.js";
import { LoadingEmail, CompletingEmailAuth } from "./loading/email.js";
import { LoadingPasskeyAuth } from "./loading/passkey.js";
import { MainAuthContent } from "./main.js";
import { PasskeyAdded } from "./passkey-added.js";
// eslint-disable-next-line jsdoc/require-jsdoc
export const Step = () => {
    const { authStep } = useAuthContext();
    switch (authStep.type) {
        case "email_verify":
            return _jsx(LoadingEmail, { authStep: authStep });
        case "passkey_verify":
            return _jsx(LoadingPasskeyAuth, {});
        case "email_completing":
            return _jsx(CompletingEmailAuth, { authStep: authStep });
        case "passkey_create":
            return _jsx(AddPasskey, { authStep: authStep });
        case "passkey_create_success":
            return _jsx(PasskeyAdded, {});
        case "eoa_connect":
            return _jsx(EoaConnectCard, { authStep: authStep });
        case "pick_eoa":
            return _jsx(EoaPickCard, {});
        case "wallet_connect":
            return _jsx(WalletConnectCard, { authStep: authStep });
        case "complete":
        case "initial":
        default:
            return _jsx(MainAuthContent, { authStep: authStep });
    }
};
//# sourceMappingURL=steps.js.map